export default Object.freeze({
  NUMBER_OF_ALLOWED_WEBSITES: 3,
});
